<template>
  <CFooter :fixed="false">
    <div>
      <span>&copy; {{new Date().getFullYear()}} ONDA</span>
      <span class="ml-1"> - Objetivos Novos de Apostolado</span>
    </div>
    <div class="ml-auto">
      <a href="https://diocese.org.br/" target="_blank">Diocese de Novo Hamburgo</a>
    </div>
  </CFooter>
</template>

<script>
export default {
  name: 'TheFooter'
}
</script>
<style scoped>
@media (max-width: 575px) {
  .c-footer {
    justify-content: center;
  }
  .ml-auto {
    margin-left: 0 !important;
  }
}
</style>